import { useRef } from 'react'
import { Button } from './primitives/Button'
import { Dialog } from './overlays/Dialog'

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'default',
  isDestructive = false,
  loading = false,
  onConfirm,
  onCancel,
  // The control that asked, and where focus goes when confirming removed
  // it (#1054).
  returnFocusRef,
  returnFocusFallbackRef,
}) {
  const danger = isDestructive || variant === 'danger'
  const cancelRef = useRef(null)
  return (
    <Dialog
      open={open}
      title={title}
      description={message}
      onClose={onCancel}
      dismissable={!loading}
      hideCloseButton={loading}
      initialFocusRef={cancelRef}
      returnFocusRef={returnFocusRef}
      returnFocusFallbackRef={returnFocusFallbackRef}
      footer={(
        <>
          <Button ref={cancelRef} variant="secondary" onClick={onCancel} disabled={loading}>{cancelLabel}</Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>{confirmLabel}</Button>
        </>
      )}
    />
  )
}
